import type { ApolloCache } from "@apollo/client/cache"
import cloneDeep from "lodash-es/cloneDeep"

import {
  TeamsDocument,
  TeamsQuery,
  TeamsQueryVariables
} from "../graphql/queries.generated"

export function readTeams(cache: ApolloCache<object>) {
  return cloneDeep(
    cache.readQuery<TeamsQuery, TeamsQueryVariables>({
      query: TeamsDocument,
      optimistic: true
    })?.teams
  )
}
